import GetIntegrationCallByIdRequestModelBase from '../_generated/modelBases/get-integration-call-by-id-request-model-base';

export default class GetIntegrationCallByIdRequestModel extends GetIntegrationCallByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
